export const buildSearch = ({ doctorName,city, q, date }) => {
    
    let search = '?';
    search += doctorName ? `doctorName=${doctorName}&` : '';
    search += city ? `city=${city}&` : '';
    search += q ? `q=${q}&` : '';
    search += date ? `date=${date}&` : '';

    return search;
};
